<cache-date></cache-date>

<br>
<div class="form-group">
	<ng-container *ngFor="let dateType of filter.filterParams.dateFilterParams | keys">
		{{ 'adminstat.filterForm.' + dateType | translate }}
		<select class="form-control" [(ngModel)]="filter.filterParams.dateFilterParams[dateType].type" [ngModelOptions]="{standalone: true}" [sextant]="'filter-dateType.' + dateType">
			<option *ngFor="let opt of ['all', 'now', 'yesterday', 'prevWeek', 'prevMonth', 'last7day', 'last30day', 'other']"
					value="{{ opt }}" [selected]="opt == filter.filterParams.dateFilterParams[dateType].type">{{ 'adminstat.common.interval.' + opt | translate }}
			</option>
		</select>
		<table>
			<tr [style.display]="filter.filterParams.dateFilterParams[dateType].type != 'other' ? 'none' : null">
				<td>
					<datepicker [(ngModel)]="filter.filterParams.dateFilterParams[dateType].start" [ngModelOptions]="{standalone: true}" [format]="'DD-MM-YYYY'"></datepicker>
					<datepicker [(ngModel)]="filter.filterParams.dateFilterParams[dateType].end" [ngModelOptions]="{standalone: true}" [format]="'DD-MM-YYYY'"></datepicker>
				</td>
			</tr>
		</table>
	</ng-container>

	{{ 'adminstat.common.Email' | translate }}
	<input class="form-control" [(ngModel)]="filter.filterParams.email" [ngModelOptions]="{standalone: true}">

	<br><br>

	<button type="button" class="btn btn-success" (click)="applyFilters()">{{ 'adminstat.common.Apply' | translate }}</button>
	<button type="button" class="btn btn-link" style="color:red;" (click)="resetFilters()">{{ 'adminstat.common.Reset filters' | translate }}</button>
</div>

<br>

<h3>{{ 'adminstat.mails.mail_status.last 50 mail shown' | translate }}</h3>

<br><br>

<loading [isLoad]="loader"></loading>
<div class="row" *ngIf="stats && stats.length > 0" [sextant]="'stats'" [url]="filter.currentUrl">
	<div class="col-md-12">
		<div class="table-responsive">
			<table class="table">
				<thead>
					<th>{{ 'adminstat.common.Date' | translate }}</th>
					<th>{{ 'adminstat.mails.mail_status.address' | translate }}</th>
					<th>{{ 'adminstat.common.Subject' | translate }}</th>
					<th>{{ 'adminstat.mails.mail_status.details' | translate }}</th>
				</thead>
			
				<tbody>
					<tr *ngFor="let stat of stats; let i = index" [ngClass]="(stat.status && !stat.isBlackList) ? 'table-success' : 'table-danger'">
						<td class="text-nowrap">
							{{ stat.dateCreated }}
						</td>
						
						<td>
							<a [href]="'https://ukit.com/admin/support#/?value=' + stat.to" target="_blank">{{ stat.to }}</a>
						</td>
						
						<td>
							<b>subjectType:</b> {{ stat.subjectType }}
							<br>
							<b>subject:</b> {{ stat.subject }}
							<br>
							<b>subject:</b>&nbsp;<a href="#" (click)="showBody(stat._id, $event)">смотреть</a>
							<br>
							
							<ng-container *ngIf="stat.isBlackList">
								<br>
								<span class="badge badge-secondary">BLACKLIST</span>
							</ng-container>
						</td>
						
						<td>
							<ngb-accordion #acc="ngbAccordion">
								<ngb-panel title="{{ 'adminstat.mails.mail_status.show extended info' | translate }}">
									<ng-template ngbPanelContent>
										<table class="table">
											<tr>
												<td>messageId</td>
												<td>{{ stat.messageId }}</td>
											</tr>
											
											<tr>
												<td>dateCreated</td>
												<td>{{ stat.dateCreated }}</td>
											</tr>
											
											<tr>
												<td>dateSent</td>
												<td>{{ stat.dateSent }}</td>
											</tr>
											
											<tr>
												<td>domain</td>
												<td>{{ stat.domain }}</td>
											</tr>
											
											<tr>
												<td>from</td>
												<td>{{ stat.from }}</td>
											</tr>
											
											<tr>
												<td>lang</td>
												<td>{{ stat.lang }}</td>
											</tr>
											
											<tr>
												<td>transport</td>
												<td>{{ stat.transport }}</td>
											</tr>
											
											<tr>
												<td>in blacklist</td>
												<td>{{ stat.isBlackList ? 'yes' : 'no' }}</td>
											</tr>
											
											<tr>
												<td>is unsubscribed</td>
												<td>{{ stat.isUnsubscribed ? 'yes' : 'no' }}</td>
											</tr>
										</table>				
									</ng-template>
								</ngb-panel>
							</ngb-accordion>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>
